import { Box, Image, Stack, Text } from "@chakra-ui/react";

export default function AdjacentPlacesOfAttraction() {
  return (
    <div
      style={{
        lineHeight: "2",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    >
      {/* Tournament Logo Section */}
      <div style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "22px", marginBottom: "15px" }}>
          {" "}
          निकटवर्ती आकर्षण स्थल
        </h2>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          <strong>राजगीर के निकट</strong>
          <br />
          प्राचीन शहर राजगृह, जिसे अब <b>राजगीर</b> के नाम से जाना जाता है,
          नालंदा से 15 किमी दूर स्थित है। हिंदू महाकाव्य <b>रामायण</b> में इसका
          उल्लेख है कि राजा वसु ने इसका नाम <b>वसुमति</b> रखा था। 'राजाओं का घर'
          के रूप में प्रसिद्ध यह शहर <b>मगध</b> काल के दौरान अपने चरम पर था। कभी
          बिंबिसार की राजधानी रहा यह शहर हिंदुओं, बौद्धों और जैनियों के लिए एक
          प्रमुख केंद्र था। बौद्ध विद्वान <b>बुद्धघोष</b> के लेखों में भी इसका
          उल्लेख है, जिसमें बताया गया है कि यह पहाड़ियों से घिरा था और इसके 32
          मुख्य द्वार और 64 छोटे द्वार थे। भगवान बुद्ध और भगवान महावीर ने यहाँ
          कई साल बिताए। राजगीर गर्म पानी के झरनों के लिए भी प्रसिद्ध है।{" "}
          <b>राजगीर महोत्सव</b> बिहार पर्यटन द्वारा आयोजित एक अंतर्राष्ट्रीय
          उत्सव है।
        </p>

        {/* <h5 style={{ textAlign: "justify", marginBottom: "15px" }}>Key Components of the Logo:</h5> */}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "30px",
          }}
        >
          <div style={{ flex: "12" }}>
            <ol style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyle: "auto" }}>
                <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                  <Box flex="1">
                    <Text fontWeight="bold">
                      राजगीर जू सफारी एवं नेचर सफारी
                    </Text>
                    <Text>
                      राजगीर जू सफारी की जैव विविधता में मांसाहारी, शांत
                      शाकाहारी, पक्षी-जगत और विभिन्न प्रकार के पौधे शामिल हैं,
                      जो पारिस्थितिकी तंत्र को बनाए रखने और संतुलित करने में
                      महत्वपूर्ण भूमिका निभाते हैं। यहां आपको रॉयल बंगाल टाइगर,
                      शेर, तेंदुआ, स्लॉथ बेयर, चीतल, सांभर, काला हिरण, हॉग-डीयर,
                      बार्किंग डीयर, रंगीन तितलियां , आदि देखने को मिलेंगे। आप
                      पौधों की विविध रूपों को देखकर चकित रह जाएंगे। नेचर सफारी
                      राजगीर-जेठियन घाटी में स्थित है; यहाँ आप हरे-भरे परिदृश्य,
                      चट्टानी पहाड़ियों और एक लुभावनी वादियों की प्राकृतिक
                      सुंदरता का आनंद ले सकते हैं।
                    </Text>
                  </Box>
                  <Image
                    src="./img/rajgirSSS.jpg"
                    alt="Description of the image"
                    objectFit="cover"
                    boxSize={{ base: "100%", lg: "50%", height: "10rem" }} // Adjusts size based on screen
                  />
                </Stack>
              </li>

              <li style={{ listStyle: "auto" }}>
                <strong>विश्व शांति स्तूप</strong>
                <br />
                विश्व शांति स्तूप 1969 में रत्नागिरी पहाड़ी पर बनाया गया सफेद
                संगमरमर का एक स्तूप है। इसके गुंबद पर भगवान बुद्ध की चार सुनहरी
                प्रतिमाएं हैं। 129 फीट ऊंचा यह स्तूप सीढ़ियों या रोपवे से पहुंचा
                जा सकता है।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>गृद्धकूट पहाड़ी की चोटी</strong>
                <br />
                भगवान बुद्ध का ध्यान करने का यह प्रमुख स्थल गृद्धकूट पहाड़ी की
                चोटी पर स्थित है। उन्होंने यहाँ अपने शिष्यों को कई उपदेश दिए। यह
                आयताकार लाल ईंटों का बना है, जिसके तीन तरफ 2 फीट ऊंची दीवारें
                हैं। ज़ुआनज़ांग के प्राचीन लेखों में बताया गया है कि इसके रास्ते
                और सीढ़ियां राजा **बिंबिसार** द्वारा बनवाई गई थीं।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>पांडु पोखर</strong>
                <br />
                बुद्ध की प्रतिकृतियों को देखने के लिए अवकाश आकर्षण पर जाएँ,
                गुलाब उद्यान और मनोरंजन उद्यान में टहलें; रेस्तरां में विभिन्न
                पारंपरिक व्यंजनों का आनंद लें या हस्तशिल्प की खरीदारी करें।
              </li>
            </ol>
          </div>
        </div>
      </div>

      {/* Mascot Section */}
      <div style={{ lineHeight: "2", marginTop: "30px" }}>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          <strong>नालंदा के निकट</strong>
          <br />
        </p>
        {/* <h5 style={{ textAlign: "justify", marginBottom: "15px" }}>Key Components of the Logo:</h5> */}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "30px",
          }}
        >
          <div style={{ flex: "12" }}>
            <ol style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyle: "auto" }}>
                <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                  <Box flex="2">
                    <Text fontWeight="bold">
                      विक्रमशिला विश्वविद्यालय के अवशेष
                    </Text>
                    <Text>
                      यह विश्वविद्यालय 9वीं-13वीं शताब्दी ईस्वी के बीच फला-फूला।
                      पाल राजा धर्मपाल द्वारा स्थापित, यह एक जीवंत शिक्षा केंद्र
                      था। यहाँ दर्शनशास्त्र, धर्मशास्त्र, तत्वमीमांसा, व्याकरण,
                      तर्कशास्त्र, तंत्रवाद आदि विषय पढ़ाए जाते थे। क्रूसिफ़ॉर्म
                      संरचना वाले दो मंजिला स्तूप का एक विशाल वर्गाकार अवशेष, एक
                      पुस्तकालय और मन्नत स्तूप के साथ-साथ एक तिब्बती और एक हिंदू
                      मंदिर भी खुदाई में मिले हैं।
                    </Text>
                  </Box>
                  <Image
                    src="./img/NalandaACT.jpg"
                    alt="Description of the image"
                    objectFit="cover"
                    boxSize={{ base: "100%", lg: "50%" }} // Adjusts size based on screen
                  />
                </Stack>
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  <a
                    href="https://tourism.bihar.gov.in/en/destinations/nalanda"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      padding: "15px 30px",
                      backgroundColor: "#ff9800", // Button background color (orange)
                      color: "white", // Text color
                      textDecoration: "none", // Remove underline
                      fontWeight: "bold",
                      borderRadius: "50px", // Rounded button
                      boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)", // Shadow effect
                      transition:
                        "transform 0.3s ease, background-color 0.3s ease", // Smooth transition
                      fontSize: "16px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#e65100"; // Darker orange on hover
                      e.target.style.transform = "scale(1.1)"; // Slightly enlarge the button
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#ff9800"; // Reset background color
                      e.target.style.transform = "scale(1)"; // Reset scaling
                    }}
                  >
                    नालंदा के बारे में अधिक जानें
                  </a>

                  {/* <p style={{ marginTop: "10px", color: "#555", fontSize: "14px" }}>
                      Know more by visiting this link
                    </p> */}
                </div>
              </li>

              <li style={{ listStyle: "auto" }}>
                <strong>नालंदा विश्वविद्यालय अवशेष</strong>
                <br />
                5वीं शताब्दी ईस्वी के प्रतिष्ठित <b>नालंदा विश्वविद्यालय</b> के
                अवशेष सबसे लोकप्रिय स्थलों में से एक हैं। इसमें बौद्ध धर्म के
                लगभग 2000 शिक्षक और 10,000 छात्र रहते थे। दूर-दूर से विद्वान
                यहाँ अध्ययन करने आते थे। यह शिक्षा, वास्तुकला और बौद्ध धर्म के
                एक पूजनीय केंद्र के रूप में प्रसिद्ध था। प्रसिद्ध 7वीं शताब्दी
                ईस्वी के चीनी यात्री <b>ह्वेन त्सांग</b> के लेखों में भी इसका
                उल्लेख है, जिसमें बताया गया है कि विश्वविद्यालय का मूल क्षेत्र
                काफी बड़ा था। <b>गुप्तों</b> और <b>पालों</b> के शासनकाल में इसने
                शिक्षा और वास्तुकला में पूर्णता की ऊँचाइयों को छुआ। लाल ईंटों से
                बने इसके खंडहरों में स्तूप और विहार आदि देखे जा सकते हैं।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>दिगंबर जैन मंदिर, कुंडलपुर</strong>
                <br />
                <b>दिगंबर जैन मंदिर, कुंडलपुर</b> एक सुंदर संरचना है जो सफेद
                संगमरमर से बनी है। दिगंबर संप्रदाय के जैनियों का मानना है कि यह
                24वें तीर्थंकर, भगवान महावीर का जन्मस्थान है। मुख्य परिसर के
                अलावा, दो अन्य इमारतों में 72 जिनों (जैन तीर्थंकरों) की
                प्रतिमाएं हैं।
              </li>
              <li style={{ listStyle: "auto" }}>
                <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                  <Box flex="2">
                    <Text fontWeight="bold">जल मंदिर, पावापुरी</Text>
                    <Text>
                      जल मंदिर, पावापुरी जैनियों के लिए एक पूजनीय धार्मिक स्थल
                      है, जहाँ भगवान महावीर ने निर्वाण प्राप्त किया था। जल मंदिर
                      एक बड़े कमल के तालाब के बीच में स्थित है और उसी स्थान पर
                      बनाया गया था जहाँ उनका अंतिम संस्कार किया गया था। यह
                      राजगीर से लगभग 35 किमी की दूरी पर स्थित है।
                    </Text>
                  </Box>
                  <Image
                    src="./img/Nalanda4.jpg"
                    alt="Description of the image"
                    objectFit="cover"
                    boxSize={{ base: "100%", lg: "50%" }} // Adjusts size based on screen
                  />
                </Stack>
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>पुरातत्व संग्रहालय</strong>
                <br />
                इस संग्रहालय में बौद्ध और हिंदू काल की मूर्तियों का संग्रह है,
                जिसमें बेसाल्ट पत्थरों और कांस्य पर उकेरी गई मूर्तियां शामिल
                हैं। यहाँ टेराकोटा की वस्तुएं, लोहे के औजार, स्टुको, पत्थरों और
                तांबे पर शिलालेख, सिक्के और मिट्टी के बर्तन, पीपल के पत्ते पर
                बने स्तूप, जले हुए चावल के नमूने आदि भी प्रदर्शित हैं।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>गिरियक पहाड़ी Stupa</strong>
                <br />
                गिरियक पहाड़ी की चोटी पर स्थित यह 21 फीट ऊंचा बेलनाकार स्तूप लाल
                ईंटों से बना है, जिसका व्यास 28 फीट है। 20 फीट चौड़ा एक पत्थर का
                रास्ता स्तूप तक जाता है। यहां से हरे-भरे परिदृश्य और शांत घोड़ा
                कटोरा झील का उत्कृष्ट दर्शन हो सकता है।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>घोड़ा कटोरा</strong>
                <br />
                राजगीर के पास स्थित, घोड़ा कटोरा का मतलब 'घोड़े का कटोरा' है; यह
                एक प्राकृतिक झील है। इसका आकार घोड़े जैसा दिखता है और यह तीन तरफ
                से पहाड़ियों से घिरा हुआ है। सर्दियों के दौरान, यहाँ साइबेरिया
                और मध्य एशिया से प्रवासी पक्षी आते हैं। झील के केंद्र में भगवान
                बुद्ध की सत्तर फीट ऊंची प्रतिमा है।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>ह्वेन त्सांग स्मारक</strong>
                <br />
                यह स्मारक (1984) चीनी विद्वान और यात्री <b>ह्वेन त्सांग</b> के
                सम्मान में बनाया गया था। उन्होंने 7वीं शताब्दी ईस्वी में भारत की
                यात्रा की और बौद्ध धर्म की शिक्षाओं को सीखने और चीनी में अनुवाद
                करने के लिए लगभग पांच साल तक यहाँ रहे। यहाँ ह्वेन त्सांग की एक
                उल्लेखनीय प्रतिमा, भगवान बुद्ध के पैरों के निशान वाली पत्थर की
                संरचना जिसकी वह पूजा करते थे, उनके गुरु <b>शीलभद्र</b> की
                पेंटिंग, और दीवारों व छतों पर रंगीन पेंटिंग देखी जा सकती हैं।
              </li>
            </ol>
          </div>
        </div>
      </div>

      <div style={{ lineHeight: "2", marginTop: "30px" }}>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          <strong>गया के निकट</strong>
          <br />
        </p>
        {/* <h5 style={{ textAlign: "justify", marginBottom: "15px" }}>Key Components of the Logo:</h5> */}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "30px",
          }}
        >
          <div style={{ flex: "12" }}>
            <ol style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyle: "auto" }}>
                <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                  <Box flex="2">
                    <Text fontWeight="bold">महाबोधि मंदिर, बोधगया</Text>
                    <Text>
                      170 फीट ऊंचा यह मंदिर ऊपरी हिस्से तक एक पतले पिरामिड की
                      तरह है, जिसका शीर्ष बेलनाकार है। इसके ऊपर लगे छत्र धर्म की
                      संप्रभुता को दर्शाते हैं। इसकी वास्तुकला में विभिन्न
                      संस्कृतियों का मिश्रण दिखाई देता है और यह गुप्त काल के
                      प्रभाव को दर्शाता है। इसमें 7वीं से 10वीं शताब्दी ईस्वी के
                      बीच श्रीलंका, म्यांमार और चीन से आए तीर्थयात्रियों के बारे
                      में शिलालेख भी स्थित हैं। यहाँ आप बुद्ध की एक विशाल
                      प्रतिमा देख सकते हैं, जो भूमिस्पर्श (दाहिने हाथ से धरती को
                      छूते हुए) मुद्रा में है, इसी मुद्रा में बुद्ध को ज्ञान
                      प्राप्त हुआ था।
                    </Text>
                  </Box>
                  <Image
                    src="./img/gayaturist.jpg"
                    alt="Description of the image"
                    objectFit="cover"
                    boxSize={{ base: "100%", lg: "50%" }} // Adjusts size based on screen
                  />
                </Stack>
              </li>

              <li style={{ listStyle: "auto" }}>
                <strong>महाबोधि वृक्ष</strong>
                <br />
                बोधगया स्थित महाबोधि वृक्ष एक पीपल का पेड़ है। इसी वृक्ष के
                नीचे, जिसे वज्रासन (स्थिरता का आसन) कहते हैं, बैठकर भगवान बुद्ध
                ने परम ज्ञान और आत्मज्ञान प्राप्त किया था।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>80 फीट विशाल बुद्ध प्रतिमा</strong>
                <br />
                आधुनिक भारत में बनी पहली विशाल बुद्ध प्रतिमा 80 फीट ऊंची है,
                जिसे 1989 में प्रतिष्ठित किया गया था। इस समारोह में परम पावन
                दलाई लामा भी उपस्थित थे। यह प्रतिमा महाबोधि मंदिर के पास स्थित
                है।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>अनिमेषलोचन स्तूप</strong>
                <br />
                ऐसा माना जाता है कि ज्ञान प्राप्त करने के बाद, भगवान बुद्ध ने एक
                सप्ताह तक बिना पलक झपकाए इस स्तूप के स्थान से महान बोधि वृक्ष को
                निहारा था।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>चंक्रमन स्थल</strong>
                <br />
                ज्ञान प्राप्त करने के बाद, बुद्ध ने इस पवित्र स्थान के चारों ओर
                भ्रमण किया। उनके पदचिह्न और 19 कमल के फूल काले पत्थर पर अंकित
                हैं।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>रत्नघर</strong>
                <br />
                ज्ञान प्राप्ति के बाद, बुद्ध ने ध्यान किया; उनके व्यक्तित्व से
                पांच अलग-अलग रंगों का एक पवित्र प्रकाश निकला। इस दिव्य घटना को
                श्रद्धांजलि देने के लिए, ध्यान मुद्रा में एक प्रतिमा बनाई गई थी।
                ये पांच रंग बौद्ध ध्वज में मौजूद हैं।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>श्री महाबोधी महाविहार</strong>
                <br />
                महाबोधि मंदिर के पास स्थित, यह विहार 2007 में महाबोधि सोसाइटी ऑफ
                इंडिया द्वारा बनाया गया था। बुद्ध के दो शिष्यों, सारीपुत्र और
                महामाल्यायन, के प्राचीन अवशेष कलश यहाँ सुरक्षित रखे गए हैं।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>डुंगेश्वरी पहाड़ी गुफा</strong>
                <br />
                माना जाता है कि गौतम बुद्ध ने बोधगया जाने से पहले यहां लंबे समय
                तक ध्यान किया था। एक गुफा मंदिर में सोने की बुद्ध प्रतिमा है,
                जबकि दूसरे में एक लंबी बुद्ध प्रतिमा रखी गई है। एक और मंदिर के
                अंदर हिंदू देवी डुंगेश्वरी की भी एक प्रतिमा है। मंदिरों तक जाने
                के लिए एक पक्का रास्ता है, और वहाँ बुद्ध की कई प्रतिमाओं की
                नक्काशी भी है।
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>विष्णुपद मंदिर</strong>
                <br />
                1787 में, देवी अहिल्या बाई होल्कर ने फल्गु नदी के तट पर विष्णुपद
                मंदिर का वर्तमान ढांचा बनवाया था। इसकी वास्तुकला सुंदर है और यह
                बड़ी संख्या में भक्तों को आकर्षित करता है।
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div style={{ lineHeight: "2", marginTop: "30px" }}>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          <strong>नवादा के निकट</strong>
          <br />
        </p>
        {/* <h5 style={{ textAlign: "justify", marginBottom: "15px" }}>Key Components of the Logo:</h5> */}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "30px",
          }}
        >
          <div style={{ flex: "12" }}>
            <ol style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyle: "auto" }}>
                <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                  <Box flex="2">
                    <Text fontWeight="bold">काकोलत झरना</Text>
                    <Text>
                      यह जलप्रपात पर्यटकों और आगंतुकों के लिए एक प्रमुख आकर्षण
                      है। नवादा से लगभग 33 किमी दूर स्थित, यह 150 फीट से अधिक
                      ऊंचा है।
                    </Text>
                  </Box>
                </Stack>
              </li>
            </ol>
          </div>
        </div>
        <p>
          <strong>
            बिहार पर्यटन के बारे में जानने के लिए, बिहार पर्यटन की आधिकारिक
            वेबसाइट पर जाएँ{" "}
            <a
              href="https://tourism.bihar.gov.in/en"
              target="_blank"
              style={{ color: "blue", textDecoration: "underline" }}
            >
              https://tourism.bihar.gov.in/en{" "}
            </a>
          </strong>
        </p>
      </div>
    </div>
  );
}
